import React from 'react'
import { useTranslation } from 'react-i18next'

export const HeroSection: React.FC = () => {
  const { t } = useTranslation()
  const hero = t('hero', { returnObjects: true }) as any

  const redirectToApp = () => {
    const mainAppUrl = import.meta.env.VITE_MAIN_APP_URL || 'https://app.nazwolab.pl'
    window.location.href = mainAppUrl
  }

  return (
    <section className="pt-24 pb-16 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
          {hero.title}
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
            {hero.subtitle}
          </span>
        </h1>

        <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed mb-8">
          {hero.description}
        </p>

        <button
          onClick={redirectToApp}
          className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all duration-200 text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1"
        >
          {hero.cta}
          <span className="ml-2">→</span>
        </button>

        <div className="mt-12 flex flex-wrap justify-center items-center gap-8 text-sm">
          {hero.features.map((feature: any, index: number) => (
            <div key={index} className="flex items-center text-gray-600">
              <div className={`w-3 h-3 rounded-full mr-3 bg-${feature.color}-500`}></div>
              <span>{feature.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}